var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRangeMiddle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0C22.6264 3.132e-08 25.2272 0.517315 27.6537 1.52241C30.0802 2.5275 32.285 4.00069 34.1421 5.85787C35.9993 7.71504 37.4725 9.91982 38.4776 12.3463C39.4827 14.7728 40 17.3736 40 20L20 20V0Z",
    fill: "#EB0000",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 20C40 22.6264 39.4827 25.2272 38.4776 27.6537C37.4725 30.0802 35.9993 32.285 34.1421 34.1421C32.285 35.9993 30.0802 37.4725 27.6537 38.4776C25.2272 39.4827 22.6264 40 20 40L20 20L40 20Z",
    fill: "#EB0000",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 40C16.8433 40 13.7314 39.2528 10.9189 37.8195C8.10634 36.3861 5.67302 34.3074 3.81793 31.7533C1.96284 29.1992 0.738672 26.2423 0.245542 23.1243C-0.247584 20.0064 0.00433552 16.816 0.980696 13.814L20 20L20 40Z",
    fill: "#EB0000",
    fillOpacity: 0.25
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M0.978869 13.8197C2.28403 9.80279 4.82734 6.30222 8.2443 3.81966C11.6612 1.3371 15.7764 -6.89609e-07 20 -8.74228e-07L20 20L0.978869 13.8197Z",
    fill: "#EB0000",
    fillOpacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRangeMiddle);
export default __webpack_public_path__ + "static/media/icon_range_middle.4c226299350c4e49583787be0db58eb6.svg";
export { ForwardRef as ReactComponent };